export default "__VITE_ASSET__D2$vkwIE__"